(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceResumeDetailController', RaceResumeDetailController);

    RaceResumeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RaceResume', 'Race', 'RunnerRaceResume'];

    function RaceResumeDetailController($scope, $rootScope, $stateParams, previousState, entity, RaceResume, Race, RunnerRaceResume) {
        var vm = this;

        vm.raceResume = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:raceResumeUpdate', function(event, result) {
            vm.raceResume = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
